import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'communities',
  children: {
    id: {
      path: ':id',
      children: {
        edit: {
          path: 'edit',
        },
        new: {
          path: 'new',
        },
        leave: {
          path: 'leave',
        },
        delete: {
          path: 'delete',
        },
        addMembers: {
          path: 'add-members',
        },
        removeMembers: {
          path: 'remove-members',
        },
      },
    },
    new: {
      path: 'new',
    },
    post: {
      path: 'post',
      children: {
        new: {
          path: 'new',
        },
        newEvent: {
          path: 'new-event',
        },
        id: {
          path: ':id',
          children: {
            edit: {
              path: 'edit',
            },
            insights: {
              path: 'insights',
            },
          },
        },
      },
    },
    posts: {
      path: 'posts',
    },
  },
} as const satisfies Location
